export default __webpack_public_path__ + "img/4fd30b03667c94157d9bd4c0514248e9.svg";